import type { FC } from 'react';

import LinkedIn from '@/components/icons/LinkedIn';
import XIcon from '@/components/icons/X';
import { track } from '@/lib/analytics/events';
import ThemeToggle from '@/ui/ThemeToggle/ThemeToggle.client';

const NavIconActions: FC = () => {
  return (
    <div className='flex items-center gap-x-5'>
      <div className='group relative cursor-pointer p-2'>
        <div className='absolute inset-0 rounded-full bg-info opacity-0 blur-md group-hover:opacity-20' />
        <div className='relative'>
          <ThemeToggle />
        </div>
      </div>
      <div className='flex items-center gap-x-0'>
        <a
          href='https://www.linkedin.com/company/bunker-suite/'
          target='_blank'
          rel='noopener noreferrer'
          className='group relative inline-flex items-center justify-center p-2'
          aria-label='Visit Bunker Suite on LinkedIn (opens in new tab)'
          data-skip-autoclick
          onClick={() => track.social({ network: 'linkedin', href: 'https://www.linkedin.com/company/bunker-suite/' })}
        >
          <div className='absolute inset-0 rounded-full bg-info opacity-0 blur-md group-hover:opacity-30' />
          <div className='relative'>
            <LinkedIn />
          </div>
        </a>
        <a
          href='https://x.com/bunkersuite'
          target='_blank'
          rel='noopener noreferrer'
          className='group relative inline-flex items-center justify-center p-2 -ml-1'
          aria-label='Visit Bunker Suite on X (opens in new tab)'
          data-skip-autoclick
          onClick={() => track.social({ network: 'x', href: 'https://x.com/bunkersuite' })}
        >
          <div className='absolute inset-0 rounded-full bg-info opacity-0 blur-md group-hover:opacity-30' />
          <div className='relative'>
            <XIcon />
          </div>
        </a>
      </div>
    </div>
  );
};

export default NavIconActions;
